// extracted by mini-css-extract-plugin
module.exports = {"locationTag":"LocationTag_locationTag__aoSSI","active":"LocationTag_active__er7em"};